import type { Branch } from "~/entities/branch/types";
import axiosInstance from "~/shared/api/axios-instance";

const API_URL = "branches/";

interface BranchResponse {
  uid: string;
  name: string;
  client: {
    uid: string;
    name: string;
  };
  branch_config: {
    status: number;
  };
  camera_orientation_count: number;
  counting_line_count: number;
  interval_zone_count: number;
  has_version: boolean;
}

export const fetchBranches = async (): Promise<Branch[]> => {
  const { data } = await axiosInstance.get<BranchResponse[]>(API_URL);

  return data.map((branch) => ({
    uid: branch.uid,
    name: branch.name,
    client: {
      uid: branch.client.uid,
      name: branch.client.name,
    },
    configStatus: branch.branch_config.status,
    cameraCount: branch.camera_orientation_count,
    lineCount: branch.counting_line_count,
    zoneCount: branch.interval_zone_count,
    hasVersion: branch.has_version,
  }));
};
